export default __webpack_public_path__ + "static/media/header-person.433a068a.svg";